import { useTranslation } from 'react-i18next';
import { useState } from 'react';

export default function LendingFAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: t('lending.faq.q1.question'),
      answer: t('lending.faq.q1.answer'),
    },
    {
      question: t('lending.faq.q2.question'),
      answer: t('lending.faq.q2.answer'),
    },
    {
      question: t('lending.faq.q3.question'),
      answer: t('lending.faq.q3.answer'),
    },
    {
      question: t('lending.faq.q4.question'),
      answer: t('lending.faq.q4.answer'),
    },
    {
      question: t('lending.faq.q5.question'),
      answer: t('lending.faq.q5.answer'),
    },
  ];

  return (
    <section className="py-16 bg-gray-800">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('lending.faq.title')}
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-900 rounded-xl border border-gray-700 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-800 transition-colors cursor-pointer"
              >
                <div className="flex items-start gap-4 flex-1">
                  <span className="bg-green-600 text-white px-3 py-1 rounded-lg font-bold text-sm flex-shrink-0">
                    Q
                  </span>
                  <span className="text-white font-semibold text-lg">
                    {faq.question}
                  </span>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <div className="flex items-start gap-4 pl-0">
                    <span className="bg-blue-600 text-white px-3 py-1 rounded-lg font-bold text-sm flex-shrink-0">
                      A
                    </span>
                    <p className="text-gray-300 leading-relaxed whitespace-pre-line">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
